jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 1025,
    spans: 'show',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });

  $('.nav-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      toggleNav();
    }
  });
  $('.nav-toggle').on('click', function () {
    toggleNav();
  });

  function toggleNav() {
    if ($('body').hasClass('nav-wrap-open')) {
      $('body').removeClass('nav-wrap-open');
      $('.nav-toggle .fa-bars').attr('aria-hidden', 'false');
      $('.nav-toggle .fa-times').attr('aria-hidden', 'true');


      // $('.mask-element').animate({
      //   height: '200%'
      // }, 0);

      $(".mask-element").animate({
        top: "-100%"
      }, 700);

      $(".nav-mask").delay(500).animate({
        opacity: 0
      }, 0);
    } else {
      $('body').addClass('nav-wrap-open');
      $('.nav-toggle .fa-bars').attr('aria-hidden', 'true');
      $('.nav-toggle .fa-times').attr('aria-hidden', 'false');


      $(".mask-element").delay(750).animate({
        top: "100%"
      }, 700);

      $(".nav-mask").delay(900).animate({
        top: 0,
        height: "100%",
        opacity: 1
      }, 0);

      // $('.mask-element').delay(1650).animate({
      //   height: 0
      // });
    }
  }

  // search
  $('.search-form > button').click(function (e) {
    e.preventDefault();
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $('.search-form input[type="search"]').val();
    var url = root + terms;
    // console.log(url);
    window.location.href = url;
  });
  $('.search-form input[type="search"]').on('keyup', function (e) {
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $(this).val();
    var url = root + terms;
    // console.log(url);
    if (e.which === 13) {
      window.location.href = url;
    }
  });
  $(".search-form input[type='search']").focusin(function () {
    $('.search-form').addClass('active');
  });
  $(".search-form input[type='search']").focusout(function () {
    $('.search-form').removeClass('active');
  });

  $(document, 'body').scroll(function () {


    var scroll = ((document.body.scrollTop == 0) ? $(window).scrollTop() : document.body.scrollTop);
    if (scroll >= 500 && scroll <= 700) {
      $("header").addClass("stuck");
      $('header').removeClass('show');
    } else if (scroll < 500) {
      $("header").removeClass('stuck');
      $('header').removeClass('show');
    } else if (scroll > 505) {
      $('header').addClass('show');
    } else {
      $("header").removeClass('stuck');
      $('header').removeClass('show');
    }
  });

  $('.main-content').responsivevideos();
  $('.main-content').tabs();
  $('.main-content').accordions();

  $('a[role*="tooltip"]').on('click', function (e) {
    e.preventDefault();
    var tipId = $(this).attr('href');
    $('#' + tipId).toggle();
  });

  $('.view-bio').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $(this).prev().slideToggle( "slow" );
    if($('.view-bio').hasClass('is-active')) {
      $(this).text('Close Bio');
    } else {
      $(this).text('View Bio');
    }
  });

});